var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.tags),function(tag){return _c('div',{key:tag.key,staticClass:"inline-block"},[_c('tag',{attrs:{"icon":tag.icon,"text":tag.text,"color":tag.color}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }